import {
  useMutation,
  UseMutationOptions,
} from "@tanstack/react-query";
import {
  createCheckoutLink,
  CreateCheckoutLinkParams,
} from "@/api/v1-jwt/checkout/checkout";
import { CreateCheckoutLinkResponse } from "./types";

export const useCreateCheckoutLink = (
  options?: Omit<
    UseMutationOptions<
      CreateCheckoutLinkResponse,
      Error,
      CreateCheckoutLinkParams
    >,
    "mutationFn"
  >
) => {
  return useMutation<
    CreateCheckoutLinkResponse,
    Error,
    CreateCheckoutLinkParams
  >({
    mutationFn: createCheckoutLink,
    ...options,
  });
};
